// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4478) return "static/chunks/4478.ada7a4c589fb0340.js";
	if (chunkId === 5269) return "static/chunks/5269.2966ecf793d55822.js";
	if (chunkId === 3195) return "static/chunks/3195.ee1d59aa48b9d47d.js";
	if (chunkId === 2485) return "static/chunks/2485.d9c40ce2ce58a7b4.js";
	if (chunkId === 8268) return "static/chunks/8268.bc9399fe1d0e7fe5.js";
	if (chunkId === 1717) return "static/chunks/1717.18f9d8319cbf0f1c.js";
	if (chunkId === 7045) return "static/chunks/7045.3f8f8b0e07e587bb.js";
	if (chunkId === 8788) return "static/chunks/8788.014ce9ea4e449b98.js";
	if (chunkId === 1761) return "static/chunks/d0deef33.0e085191e298c811.js";
	if (chunkId === 9177) return "static/chunks/9177.65eb7fcff66ae79c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1141":"875f07548b5132e5","1484":"eb5735f1f70ef6c1","2722":"be5f2825b54fdd02","3289":"7b8496fd8f837734","5402":"23cfc1cfe90fa37d","6476":"ca87fd206959db65","6649":"4c510b755b173de3","7754":"483b5379b55675b7","7866":"bfd500d78cdd7048","8118":"4ad0b559a457c8c9","8188":"6bd7fd69a1fb2907","8536":"ef354680d3592669"}[chunkId] + ".js";
};